import { Injectable, inject } from '@angular/core';
import { Observable, of, delay, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { InstagramPost, InstagramFeedResponse } from '../models/instagram-post.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstagramService {
  private apiService = inject(ApiService);

  // Mock data per sviluppo/test
  private mockPosts: InstagramPost[] = [
    {
      id: '1',
      permalink: 'https://www.instagram.com/p/example1/',
      mediaType: 'IMAGE',
      mediaUrl: 'https://placehold.co/600x600?text=Instagram+Post+1',
      caption: 'Post di esempio da Instagram - Educazione finanziaria',
      timestamp: new Date().toISOString(),
      username: 'dopt_finanza',
      likeCount: 150,
      commentsCount: 12
    },
    {
      id: '2',
      permalink: 'https://www.instagram.com/p/example2/',
      mediaType: 'IMAGE',
      mediaUrl: 'https://placehold.co/600x600?text=Instagram+Post+2',
      caption: 'Consigli pratici per la gestione finanziaria',
      timestamp: new Date(Date.now() - 86400000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 230,
      commentsCount: 18
    },
    {
      id: '3',
      permalink: 'https://www.instagram.com/p/example3/',
      mediaType: 'VIDEO',
      mediaUrl: 'https://placehold.co/600x600?text=Video+Post',
      thumbnailUrl: 'https://placehold.co/600x600?text=Video+Thumbnail',
      caption: 'Video educativo su investimenti',
      timestamp: new Date(Date.now() - 172800000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 320,
      commentsCount: 25
    },
    {
      id: '4',
      permalink: 'https://www.instagram.com/p/example4/',
      mediaType: 'IMAGE',
      mediaUrl: 'https://placehold.co/600x600?text=Instagram+Post+4',
      caption: 'Focus su risparmio e pianificazione a lungo termine',
      timestamp: new Date(Date.now() - 259200000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 180,
      commentsCount: 9
    },
    {
      id: '5',
      permalink: 'https://www.instagram.com/p/example5/',
      mediaType: 'CAROUSEL_ALBUM',
      mediaUrl: 'https://placehold.co/600x600?text=Carousel+Post',
      caption: 'Checklist di controllo finanziario mensile',
      timestamp: new Date(Date.now() - 345600000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 210,
      commentsCount: 14
    },
    {
      id: '6',
      permalink: 'https://www.instagram.com/p/example6/',
      mediaType: 'VIDEO',
      mediaUrl: 'https://placehold.co/600x600?text=Video+Post+2',
      thumbnailUrl: 'https://placehold.co/600x600?text=Video+Thumbnail+2',
      caption: 'Come costruire un fondo di emergenza',
      timestamp: new Date(Date.now() - 432000000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 290,
      commentsCount: 31
    },
    {
      id: '7',
      permalink: 'https://www.instagram.com/p/example7/',
      mediaType: 'IMAGE',
      mediaUrl: 'https://placehold.co/600x600?text=Instagram+Post+7',
      caption: 'Investire in modo consapevole: consigli pratici',
      timestamp: new Date(Date.now() - 518400000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 175,
      commentsCount: 8
    },
    {
      id: '8',
      permalink: 'https://www.instagram.com/p/example8/',
      mediaType: 'CAROUSEL_ALBUM',
      mediaUrl: 'https://placehold.co/600x600?text=Carousel+Post+2',
      caption: 'Le 5 regole d’oro per il budget familiare',
      timestamp: new Date(Date.now() - 604800000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 260,
      commentsCount: 22
    },
    {
      id: '9',
      permalink: 'https://www.instagram.com/p/example9/',
      mediaType: 'IMAGE',
      mediaUrl: 'https://placehold.co/600x600?text=Instagram+Post+9',
      caption: 'Pianificare la pensione partendo dai 30 anni',
      timestamp: new Date(Date.now() - 691200000).toISOString(),
      username: 'dopt_finanza',
      likeCount: 340,
      commentsCount: 27
    }
  ];

  /**
   * Ottiene i post Instagram della pagina pubblica
   * @param limit Numero massimo di post da recuperare (default: 9)
   * @param after Cursor per la paginazione
   */
  getPosts(limit: number = 9, after?: string): Observable<InstagramFeedResponse> {
    let params = new HttpParams();
    if (limit !== undefined && limit !== null) {
      params = params.set('limit', limit.toString());
    }
    if (after) {
      params = params.set('after', after);
    }

    // const mockPosts = limit !== undefined && limit !== null
    //   ? this.mockPosts.slice(0, limit)
    //   : [...this.mockPosts];
    // return of(mockPosts).pipe(delay(500));


    return this.apiService.get<InstagramFeedResponse>('/instagram/posts', params);
    //   map(response => {
    //     if (response && response.posts && Array.isArray(response.posts)) {
    //       if (limit !== undefined && limit !== null) {
    //         return response.posts.slice(0, limit);
    //       }
    //       return response.posts;
    //     }
    //     console.warn('Risposta API Instagram non valida:', response);
    //     return [];
    //   }),
    //   catchError((error) => {
    //     // Fallback a mock solo in caso di errore (per sviluppo/test)
    //     console.warn('Errore nel recupero post Instagram, uso dati mock:', error);
    //     if (!environment.production) {
    //       const mockPosts = limit !== undefined && limit !== null
    //         ? this.mockPosts.slice(0, limit)
    //         : [...this.mockPosts];
    //       return of(mockPosts).pipe(delay(500));
    //     }
    //     // In produzione restituisci array vuoto
    //     return of([]);
    //   })
    // );
  }

  /**
   * Ottiene un singolo post per ID
   */
  getPostById(id: string): Observable<InstagramPost> {
    return this.apiService.get<InstagramPost>(`/instagram/posts/${id}`).pipe(
      catchError((error) => {
        console.warn('Errore nel recupero post Instagram:', error);
        // Fallback a mock solo in sviluppo
        if (!environment.production) {
          const post = this.mockPosts.find(p => p.id === id);
          if (post) {
            return of({ ...post }).pipe(delay(300));
          }
        }
        return throwError(() => new Error('Post non trovato'));
      })
    );
  }
}

